import type { JobWithRelations } from "@/types/db";

export const JOB_VALID_DAYS = 30;

const INVALID_COMPANY_NAMES = new Set([
  "company",
  "company name",
  "name",
  "thumbnail_url",
  "unknown",
]);

export function companyDisplayName(job: JobWithRelations): string {
  const candidates = [job.company?.name, job.companyName];
  for (const candidate of candidates) {
    const name = candidate?.trim();
    if (name && !INVALID_COMPANY_NAMES.has(name.toLowerCase())) return name;
  }
  return "Company";
}

export function isJobPostingEligible(
  job: JobWithRelations,
  now: Date = new Date(),
): boolean {
  if (
    job.isActive === false ||
    !job.createdAt ||
    companyDisplayName(job) === "Company"
  )
    return false;
  const created = new Date(job.createdAt);
  if (Number.isNaN(created.getTime())) return false;
  const validThrough = new Date(created);
  validThrough.setUTCDate(validThrough.getUTCDate() + JOB_VALID_DAYS);
  return validThrough.getTime() >= now.getTime();
}

export function jobValidThrough(job: JobWithRelations): string | undefined {
  if (!job.createdAt) return undefined;
  const created = new Date(job.createdAt);
  if (Number.isNaN(created.getTime())) return undefined;
  created.setUTCDate(created.getUTCDate() + JOB_VALID_DAYS);
  return created.toISOString();
}

export function shouldNoIndex(job: JobWithRelations): boolean {
  if (job.isActive === false && job.archiveDisposition === "useful")
    return false;
  return !isJobPostingEligible(job);
}
